import axiosInstance from '../utils/AxiosConfig';

export const getCategoriesByType = async (typeId) => {
    try {
        const response = await axiosInstance.get(`/category/type/${typeId}`);
        return response.data.data;
    } catch (error) {
        console.error('Error fetching categories:', error);
        return [];
    } 
};

export const updateCategoryAndSubCategories = async (category) => {
    try {
        const response = await axiosInstance.put(`/category/${category.id}/sub-categories`, category);
        return response.data.data;
    } catch (error) {
        console.error('Error updating categories:', error);
        return [];
    } 
};

export const deleteCategory = async (categoryId) => {
    try {
        const response = await axiosInstance.delete(`/category/${categoryId}`);
        return response.data.data;
    } catch (error) {
        console.error('Error deleteing category:', error);
        return [];
    } 
};

export const addCategory = async (categoryData) => {
    try {
        // Definimos la estructura básica de la petición de la categoría.
        let categoryRequest = {
            name: categoryData.name,
            type: categoryData.type,
        };
        
        // Enviamos la solicitud para crear la categoría.
        const categoryResponse = (await axiosInstance.post(`/category`, categoryRequest)).data.data;

        // Verificamos que subCategories exista y sea un array; de lo contrario, utilizamos un array vacío.
        let subcategoryRequest = (categoryData.sub_categories || []).map(sub => ({
            name: sub.name,
            category_id: categoryResponse.id
        }));

        // Enviamos la solicitud para crear las subcategorías si hay alguna.
        const subcategoryResponse = await axiosInstance.post(`/category/${categoryResponse.id}/sub-categories`, subcategoryRequest);

        return subcategoryResponse.data.data;
    } catch (error) {
        console.error('Error adding category:', error);
        return [];
    } 
};